module.exports = __webpack_public_path__ + "img/fenshi-logo.f142a899.png";